<template>
  <div>
    <search-box
      @typing="searchCity"
      @selected="selectCity"
      :results="searchedCities"
      :placeholder="this.name || 'Search city...'"
      class="w-100"
    ></search-box>
  </div>
</template>

<script>
import SearchBox from "./SearchBox.vue";
import { config } from "../helpers";

export default {
  components: { "search-box": SearchBox },

  props: ["name", "countryId"],

  data() {
    return {
      cities: [],
      searchedCities: [],
      selectedCityName: "",
    };
  },

  mounted() {
    if (this.name) {
      this.selectedCityName = this.name;
    }
  },

  methods: {
    searchCity: _.debounce(function (q) {
      axios
        .get(`${config("BACKEND_ROOT")}/admin/cities?country_id=${this.countryId}&q=${q}`)
        .then((response) => {
          this.cities = response.data.data;
          this.searchedCities = this.cities.map(el => el.name);
        });
    }, 400),

    selectCity(cityName) {
      let city = this.cities.find(el => el.name == cityName);

      this.$emit("selected", city.id);
    },
  },
};
</script>